import React from "react";
import { Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";

const NotSetValue = ({ label = "not-set" }) => (
    <Typography
        sx={{
            color: "text.disabled",
            fontStyle: "italic",
        }}
    >
        <FormattedMessage id={label} />
    </Typography>
);

export default NotSetValue;
